import { ChangeDetectionStrategy, Component, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { RadioButton } from 'primeng/radiobutton';
import { Checkbox } from 'primeng/checkbox';

export type PublishMode = 'diff' | 'replace';

export interface PublishRequest {
	mode: PublishMode;
	subtitles: boolean;
}

/**
 * Asked before every publish. The mode choice is shown only for a project that
 * is already live — with an empty bucket both modes do the same thing.
 */
@Component({
	selector: 'app-publish-mode-dialog',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [Dialog, FormsModule, Button, RadioButton, Checkbox],
	templateUrl: './publish-mode-dialog.html',
	styleUrl: './publish-mode-dialog.scss',
})
export class PublishModeDialogComponent {
	visible = model(false);
	slug = input<string>('');
	published = input(false);

	confirmed = output<PublishRequest>();

	protected mode = signal<PublishMode>('diff');
	// Off by default: cue JSON in the bucket is often hand-edited after publish.
	protected subtitles = signal(false);

	protected confirm(): void {
		this.confirmed.emit({ mode: this.mode(), subtitles: this.subtitles() });
		this.visible.set(false);
	}

	protected cancel(): void {
		this.visible.set(false);
	}

	protected onOpen(): void {
		this.mode.set('diff');
		this.subtitles.set(false);
	}
}
